import React from 'react'
import { useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { isOnlyPerfumeCasesInCartSelector } from 'common/helpers'

import SectionHeadline from 'components/cart/SectionHeadline/SectionHeadline'

import messages from './messages'


const CartProductsTitle = ({ withShipping }) => {
  const { isOnlyPerfumeCases } = useConnect({
    isOnlyPerfumeCases: isOnlyPerfumeCasesInCartSelector(),
  })

  const subTitle = useMemo(() => (
    isOnlyPerfumeCases ? messages.perfumeCaseText : messages.shipping
  ), [ isOnlyPerfumeCases ])

  return (
    <SectionHeadline
      titleMessage={messages.title}
      subTitleMessage={subTitle}
      withShipping={withShipping}
    />
  )
}


export default CartProductsTitle
